import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import AssetPreview from './AssetPreview'

const ViewMode: React.FC<ViewModeProps> = ({
  mainBackground,
  secondaryBackground
}) => (
  <section className="d-flex flex-column gap-3">
    {mainBackground && (
      <AssetPreview
        url={mainBackground.url}
        label={t('rm:campaign.additionalAssets.mainBackground')}
      />
    )}

    {secondaryBackground && (
      <AssetPreview
        url={secondaryBackground.url}
        label={t('rm:campaign.additionalAssets.secondaryBackground')}
      />
    )}

    {!mainBackground && !secondaryBackground && (
      <Alert variant="warning">{t('rm:campaign.noMediaRegistered')}</Alert>
    )}
  </section>
)

export default ViewMode
